var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentPerson = function SvgDocumentPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__a)",
    d: "m59.27 56.814-.001-26.63V19.49c0-.28-.111-.55-.311-.748L46.668 6.466a1.06 1.06 0 0 0-.747-.31H12.046c-.584 0-1.057.473-1.057 1.058v5.754h-4.44c-.584 0-1.057.473-1.057 1.057V72.78c0 .585.473 1.058 1.058 1.058h45.243c.584 0 1.058-.473 1.058-1.058v-4.432h5.361c.585 0 1.058-.473 1.058-1.058z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.816 13.29H18.933c-.585 0-1.058.472-1.058 1.057v16.862c0 .584.473 1.057 1.058 1.057h16.883c.584 0 1.057-.473 1.057-1.057V14.347c0-.585-.474-1.058-1.057-1.058"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__b)",
    d: "M29.464 25.178c-.19 0-.272-.313-.125-.433a3.1 3.1 0 0 0 1.141-2.404 3.11 3.11 0 0 0-3.11-3.107 3.11 3.11 0 0 0-3.11 3.107c0 .97.444 1.835 1.141 2.404.147.12.065.433-.125.433a3.95 3.95 0 0 0-3.909 3.938v2.233c0 .508.412.92.92.92h10.166a.92.92 0 0 0 .92-.92v-2.233c.001-2.155-1.756-3.92-3.91-3.938"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__c)",
    d: "M51.328 26.482H40.706a1.057 1.057 0 1 1 0-2.115h10.621a1.057 1.057 0 1 1 0 2.115"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__d)",
    d: "M47.995 32.264h-7.289a1.057 1.057 0 1 1 0-2.116h7.289a1.057 1.057 0 1 1 0 2.116"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__e)",
    d: "M39.447 61.209H18.933a1.057 1.057 0 1 1 0-2.115h20.514a1.057 1.057 0 1 1 0 2.115"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__f)",
    d: "M12.046 68.349a1.057 1.057 0 0 1-1.057-1.058V12.97h-4.44c-.584 0-1.057.473-1.057 1.057v58.755c0 .584.473 1.057 1.058 1.057h45.243c.584 0 1.058-.473 1.058-1.057v-4.432z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__g)",
    d: "M46.669 6.463a1.05 1.05 0 0 0-.747-.307v12.405c0 .512.415.927.927.927h12.419c0-.275-.106-.546-.308-.748z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__h)",
    d: "M29.464 25.18h-.826c-.388.173-.816.27-1.268.27s-.88-.097-1.268-.27h-.826a3.95 3.95 0 0 0-3.909 3.938v3.152h12.006v-3.152c.001-2.155-1.756-3.92-3.91-3.938"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__i)",
    d: "M19.05 43.896h24.267c.334-.743.736-1.451 1.196-2.115H19.05a1.057 1.057 0 1 0 0 2.115"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__j)",
    d: "M47.992 43.896H23.725a13.3 13.3 0 0 0-1.196-2.115h25.463a1.057 1.057 0 1 1 0 2.115"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__k)",
    d: "M18.933 38.06h23.55a13.3 13.3 0 0 1 1.197-2.115H18.933a1.057 1.057 0 1 0 0 2.115"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__l)",
    d: "M47.159 38.06H23.608a13.3 13.3 0 0 0-1.197-2.115H47.16a1.057 1.057 0 1 1 0 2.115"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__m)",
    d: "M19.05 55.56h20.1a13.3 13.3 0 0 1 1.197-2.115H19.05a1.057 1.057 0 1 0 0 2.115"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__n)",
    d: "M43.826 55.56H23.725a13.3 13.3 0 0 0-1.196-2.115h21.297a1.057 1.057 0 1 1 0 2.115"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__o)",
    d: "M19.05 49.724h26.767c.334-.742.736-1.451 1.196-2.115H19.05a1.057 1.057 0 1 0 0 2.115"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__p)",
    d: "M50.492 49.724H23.725a13.3 13.3 0 0 0-1.196-2.115h27.963a1.057 1.057 0 1 1 0 2.115"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__q)",
    d: "m71.86 55.808-7.125-2.527-5.11 1.662-5.11-1.662-7.124 2.527c-1.346.478-2.243 1.726-2.243 3.123v5.148c0 .458.382.83.852.83h27.25c.471 0 .852-.372.852-.83V58.93c0-1.398-.896-2.645-2.242-3.123"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__r)",
    d: "m58.733 56.61-.811 8.305h3.406l-.81-8.306z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__s)",
    d: "M60.517 57.748H58.73a.59.59 0 0 1-.596-.582v-2.22h2.98v2.22a.59.59 0 0 1-.596.582"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__t)",
    d: "M68.993 36.158V29.2c0-.917-.763-1.66-1.703-1.66H57.07c-3.762 0-6.812 2.974-6.812 6.644v1.974c0 .893.147 1.78.437 2.626l.283.83c.087.254.131.52.131.788v.426h17.032v-.426c0-.268.044-.534.131-.788l.284-.83c.29-.846.437-1.733.437-2.626"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__u)",
    d: "M54.523 30.913c0 1.864 1.55 3.374 3.46 3.374h.479l.231 6.54h9.456v-.425c0-.268.044-.534.13-.788l.284-.83A8.1 8.1 0 0 0 69 36.158V29.2c0-.917-.762-1.66-1.703-1.66h-9.314c-1.91 0-3.46 1.51-3.46 3.373"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__v)",
    d: "M64.743 47.469h-10.22v7.474h10.22z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#D29B6E",
    d: "M54.524 50.277a10.36 10.36 0 0 0 5.109 1.344c1.863 0 3.605-.494 5.11-1.344V47.47h-10.22z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__w)",
    d: "M59.625 54.943 56.91 57.59a.866.866 0 0 1-1.28-.085l-2.816-3.619.736-1.514a.86.86 0 0 1 1.216-.35z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__x)",
    d: "m59.625 54.943 2.716 2.648a.866.866 0 0 0 1.28-.085l2.817-3.619-.737-1.514a.86.86 0 0 0-1.216-.35z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentPerson_svg__y)",
    d: "M59.625 49.957c-4.703 0-8.516-3.718-8.516-8.306v-.973c0-.44.18-.863.5-1.174l.705-.688a1.64 1.64 0 0 0 .498-1.175v-1.99c0-.386.265-.72.649-.808 2.014-.464 8.282-1.563 12.547 1.496.277.2.43.526.43.86v.442c0 .44.18.863.499 1.175l.705.688c.32.311.499.734.499 1.174v.973c0 4.587-3.812 8.306-8.516 8.306"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(132.665 31.232 19.975)scale(83.0615 76.9865)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BED7FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-10.5547 12.21652 -10.55655 -9.12053 31.474 20.012)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD9A58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.72926 1.3886 -.76034 -3.13713 48.625 24.528)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.72926 1.3886 -.76034 -3.13713 48.625 30.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-10.17942 1.38862 -.44481 -3.26074 33.825 59.255)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-21.30356 39.96178 -39.6802 -21.15344 38.87 17.603)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-6.0034 8.75234 -9.76542 -6.6983 55.328 7.171)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.40045 4.65514 -5.50666 -6.38831 29.829 25.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(174.12 18.481 21.976)scale(13.5534 3.30394)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(174.12 18.481 21.976)scale(13.5534 3.30394)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(174.12 18.572 19.055)scale(13.5534 3.30394)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(174.12 18.572 19.055)scale(13.5534 3.30394)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(174.12 18.182 27.808)scale(13.5534 3.30394)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(174.12 18.182 27.808)scale(13.5534 3.30394)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(174.12 18.331 24.89)scale(13.5534 3.30394)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(174.12 18.331 24.89)scale(13.5534 3.30394)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.0243 7.63398 -7.96616 -13.59103 65.555 54.166)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.5656 7.49495 -5.40772 -2.57263 61.823 57.148)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BED7FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.11967 2.52879 -2.30073 -2.83833 61.546 55.127)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BED7FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-10.40955 10.67862 -30.33525 -29.5709 64.439 31.437)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#856945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1205"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(126.989 24.902 32.046)scale(13.3691 36.5148)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#856945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1205"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.6781 6.00653 -17.04164 -16.10985 62.259 49.661)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-6.06417 10.00053 -8.48933 -5.1478 61.861 47.307)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__x",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-6.06417 10.00053 -8.48933 -5.1478 68.674 47.307)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentPerson_svg__y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.4631 12.60917 -34.40416 -25.82011 64.001 38.868)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })))));
};
export default SvgDocumentPerson;